var _defs, _path, _rect, _path2, _rect2, _rect3, _path3, _polygon, _polygon2, _path4, _path5, _path6, _path7, _path8, _rect4, _polygon3, _path9, _path10, _path11, _path12, _path13, _rect5, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrown03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ba8a5e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.99,80.45h-25.98c-1.95,0-3.55,1.6-3.55,3.55h33.08c0-1.95-1.6-3.55-3.55-3.55Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.88,
    y: 40.27,
    width: 22.24,
    height: 7.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.12,24.12c0-.3-.15-.59-.4-.76l-10.18-7.19c-.32-.23-.75-.23-1.08,0l-10.18,7.19c-.25.18-.4.46-.4.76v5.31h22.24v-5.31Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.88,
    y: 49.24,
    width: 22.24,
    height: 7.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.88,
    y: 31.3,
    width: 22.24,
    height: 7.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.54,68.49c0,.26.21.47.47.47h5.98c.26,0,.47-.21.47-.47v-5.14l7.66-4.76v-.37h-22.24v.37l7.66,4.76v5.14Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.75 78.86 25.75 61.61 23.88 60.45 23.88 78.86 25.75 78.86"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.45 63.36 60.45 51.45 59.24 52.2 59.24 63.36 60.45 63.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.45,50h-12.75v1.26l3.32,2.06v3.32c0,.17.14.3.3.3h3.87c.17,0,.3-.14.3-.3v-3.32l4.95-3.08v-.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.7,66.68h16.25c0-1.26-1.03-2.3-2.3-2.3h-13.95v2.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.7,42.99h12.75v-4.59h-12.75c0,.35-.11.67-.3.94.19.26.3.58.3.93v2.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.45,48.79v-4.59h-12.75v3.17c0,.35-.11.67-.3.93.11.15.19.31.24.49h12.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.7,31.39h12.75v-3.43c0-.2-.1-.38-.26-.49l-6.59-4.65c-.21-.15-.49-.15-.7,0l-5.21,3.68v2.94c0,.35-.11.67-.3.93.19.26.3.58.3.93v.09Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.7,
    y: 32.6,
    width: 12.75,
    height: 4.59
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.76 63.36 10.76 52.2 9.55 51.45 9.55 63.36 10.76 63.36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.5,56.65c0,.17.14.3.3.3h3.87c.17,0,.3-.14.3-.3v-3.32l3.32-2.06v-1.26h-12.75v.24l4.95,3.08v3.32Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.3,64.38h-13.95c-1.26,0-2.3,1.03-2.3,2.3h16.25v-2.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.3,40.27c0-.35.11-.67.3-.93-.19-.26-.3-.58-.3-.93h0s-12.75,0-12.75,0v4.59h12.75v-2.72Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.6,48.31c-.19-.26-.3-.58-.3-.93v-3.17h-12.75v4.59h12.81c.05-.18.13-.34.24-.49Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.3,31.3c0-.35.11-.67.3-.93-.19-.26-.3-.58-.3-.93v-2.94l-5.21-3.68c-.21-.15-.49-.15-.7,0l-6.59,4.65c-.16.11-.26.3-.26.49v3.43h12.75v-.09Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.55,
    y: 32.6,
    width: 12.75,
    height: 4.59
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.12 78.86 46.12 60.45 44.25 61.61 44.25 78.86 46.12 78.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrown03);
export default __webpack_public_path__ + "static/media/brown03.c9ea4b19497a78ea14f0f6972a42100e.svg";
export { ForwardRef as ReactComponent };